import { Component } from '@angular/core';
import { NavigationEnd, Router } from "@angular/router";

@Component( {
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
} )
export class AppComponent {
    title = 'sofaxis-fonpel-simulation-client';

    async ngOnInit() {
    }
}



